import React from 'react';
import FullMenu from './MenuConfig';
import styles from './styles.css';

const sortMenuItems = MenuItems => {
  // don't sort if not an array
  if (!Array.isArray(MenuItems)) {
    return MenuItems;
  }

  return MenuItems.map(item => {
    if (typeof item === 'object') {
      // check for a property with an array
      const arrayProp = Object.keys(item).find(key => {
        return Array.isArray(item[key]);
      });
      const subItems = item[arrayProp];
      if (Array.isArray(subItems)) {
        return {
          ...item,
          [arrayProp]: sortMenuItems(subItems),
        };
      }
    }
    return item;
  }).sort((a, b) => {
    if (a.order && b.order) {
      return a.order - b.order;
    }
    return 0;
  });
};

export const getFullMenu = (menuItems) => {
  // get any added menu items
  const fullMenu = menuItems && menuItems.length
    ? FullMenu.map(menuItem => {
        const newItem = menuItems.find(item => item.name === menuItem.name) || {
          items: [],
        };
        return {
          ...menuItem,
          ...newItem,
          items: [...menuItem.items, ...newItem.items],
        };
      })
    : FullMenu;

  return sortMenuItems(fullMenu);
};

const isActiveLink = (name, docTitle = '') => (
  docTitle.toLowerCase().indexOf(name.toLowerCase()) > -1
);

export const getMenuLinks = (type, fullMenu, docTitle) => {
  return fullMenu.find(f => f.name === type).items.map(m => 
    <li key={m.name}><a href={m.ref} className={isActiveLink(m.name, docTitle) ? styles["active"] : null}>{m.text}</a></li>
  );
}


// WEBPACK FOOTER //
// ./src/common/components/Layout/Header/helpers.js